import { useEffect } from "react";

export const usePerformance = () => {
  useEffect(() => {
    // Only log in development
    const isDevelopment = process.env.NODE_ENV === "development";

    // Monitor page load time
    const handleLoad = () => {
      if (performance.timing && isDevelopment) {
        const loadTime =
          performance.timing.loadEventEnd - performance.timing.navigationStart;
        console.log(`Page load time: ${loadTime}ms`);
      }
    };

    window.addEventListener("load", handleLoad);

    // Monitor memory usage (if available)
    if ("memory" in performance && isDevelopment) {
      const memory = performance.memory;
      console.log(
        `Memory usage: ${Math.round(memory.usedJSHeapSize / 1048576)}MB`
      );
    }

    // Monitor navigation timing
    if (performance.navigation && isDevelopment) {
      console.log(`Navigation type: ${performance.navigation.type}`);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);
};
